export default "__VITE_ASSET__S00Vt73k__"